export default [
  //  获取出金报表
  {
    name: "GetWithdrawalReport",
    url: "/withdrawal/list",
    method: "GET",
    mock: false,
  },
  //  导出出金报表
  {
    name: "ExportWithdrawalReport",
    url: "/withdrawal/export",
    method: "POST",
    mock: false,
  },
  //  获取入金报表
  {
    name: "GetDepositReport",
    url: "/deposit/list",
    method: "GET",
    mock: false,
  },
  //  导出入金报表
  {
    name: "ExportDepositReport",
    url: "/deposit/export",
    method: "POST",
    mock: false,
  },
  //  获取转账报表
  {
    name: "GetTransferReport",
    url: "/transfer/list",
    method: "GET",
    mock: false,
  },
  //  导出转账报表
  {
    name: "ExportTransferReport",
    url: "/transfer/export",
    method: "POST",
    mock: false,
  },
  //  获取持仓报表
  {
    name: "GetHoldingReport",
    url: "/holding/list",
    method: "GET",
    mock: false,
  },
  //  导出持仓报表
  {
    name: "ExportHoldingReport",
    url: "/holding/export",
    method: "POST",
    mock: false,
  },
  //  获取历史订单报表
  {
    name: "GetHistoryReport",
    url: "/history/list",
    method: "GET",
    mock: false,
  },
  //  导出历史订单报表
  {
    name: "ExportHistoryReport",
    url: "/history/export",
    method: "POST",
    mock: false,
  },
  //  获取佣金报表
  {
    name: "GetRebateReport",
    url: "/rebate/list",
    method: "GET",
    mock: false,
  },
  //  导出佣金报表
  {
    name: "ExportRebateReport",
    url: "/rebate/export",
    method: "POST",
    mock: false,
  },
  //  获取佣金明细报表
  {
    name: "GetRebateDetailReport",
    url: "/rebate-detail/list",
    method: "GET",
    mock: false,
  },
  //  导出佣金明细报表
  {
    name: "ExportRebateDetailReport",
    url: "/rebate-detail/export",
    method: "POST",
    mock: false,
  },
  //  查询用户交易过的品种列表
  {
    name: "GetClientSymbolList",
    url: "/symbol/list",
    method: "GET",
    mock: false,
  },
  //  获取交易服务器选项列表
  {
    name: "GetClientServerList",
    url: "/server/list",
    method: "GET",
    mock: false,
  },
  //  查询挂单报表
  {
    name: "GetClientPendingList",
    url: "/pending/list",
    method: "GET",
    mock: false,
  },
  //  导出挂单报表
  {
    name: "ExportClientPendingList",
    url: "/pending/export",
    method: "POST",
    mock: false,
  },
];
